export enum ApiCustomerTabCreditField {
  CreditType = 'credit_type',
  SumCreditAmount = 'sum_credit_amount',
  SumCreditCount = 'sum_credit_count',
}

export enum ApiCustomerTabCreditAggregate {
  PaymentMethod = 'paymentMethod',
}
